import styled from 'styled-components';
import { motion } from 'framer-motion';

export const HomeContainer = styled(motion.div)`
  height: 100hv;
  padding-top: 1%;
`
